import template from './adpMainNavigation.html';
import controller from './adpMainNavigation.controller';
import './adpMainNavigation.less';

let adpMainNavigationComponent = {
  restrict: 'E',
  bindings: {},
  transclude: true,
  template,
  controller
};

export default adpMainNavigationComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpMainNavigation/adpMainNavigation.component.js